"use client";
import { useEffect, useState } from "react";
import LogRocket from 'logrocket';
import { useLoggerContext } from "@/context/log-context";
import { useAuthContext } from "@/context/auth-context";
import { createHash } from 'crypto';

function Logger() {

  const { customerDetails } =
    useAuthContext();

  
  const {
    logger,
    setLogger
  } = useLoggerContext();

  const emailToId = (email: string): string =>{
    const normalized = email.trim().toLowerCase();
    return createHash('md5').update(normalized).digest('hex').slice(0, 8);
  }
  useEffect(() => {
    try {
      if(!logger && process.env.NEXT_PUBLIC_LOGROCKET_ID && customerDetails.email) {
        LogRocket.init(process.env.NEXT_PUBLIC_LOGROCKET_ID);
        LogRocket.identify(emailToId(customerDetails.email), {
            name: customerDetails.firstName,
            email: customerDetails.email,
        });
        setLogger(LogRocket);
      }

    } catch(e) {
      console.error('Failed to iniliatize LogRocket, please validate the credentials.')
    }

  }, [customerDetails]);

  return (
    <>
    </>
  );
}

export default Logger;
